import { MouseEvent } from 'react';
import { TableCell, TableHead as MuiTableHead, TableRow, TableSortLabel } from '@mui/material';
import { TableHeadProps } from './EnhancedTable.types';

export function TableHead<ColumnsIds>({
  order,
  orderBy,
  onRequestSort,
  columns,
  entityName,
}: TableHeadProps<ColumnsIds>) {
  const createSortHandler = (property: ColumnsIds) => (event: MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <MuiTableHead sx={{ '& tr:first-of-type th': { borderBottom: 'none' }, marginTop: '10px' }}>
      <TableRow>
        {columns.map((headCell, i) => (
          <TableCell
            key={i}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ whiteSpace: 'nowrap', ...headCell.sx }}
          >
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                data-testid={`${entityName}-table-column`}
                sx={{ whiteSpace: 'nowrap' }}
              >
                <strong>{headCell.label}</strong>
              </TableSortLabel>
            ) : (
              <strong>{headCell.label}</strong>
            )}
          </TableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
}
